// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".About_titre__1Merb.About_mobile__2XUBq {\n  margin-bottom: 0px;\n}\n", "",{"version":3,"sources":["webpack://src/Landing/Components/About.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB","sourcesContent":[".titre.mobile {\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titre": "About_titre__1Merb",
	"mobile": "About_mobile__2XUBq"
};
export default ___CSS_LOADER_EXPORT___;
